import { render, staticRenderFns } from "./FormDocument.vue?vue&type=template&id=259dd2ae&scoped=true&"
import script from "./FormDocument.vue?vue&type=script&lang=js&"
export * from "./FormDocument.vue?vue&type=script&lang=js&"
import style0 from "./FormDocument.vue?vue&type=style&index=0&id=259dd2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259dd2ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259dd2ae')) {
      api.createRecord('259dd2ae', component.options)
    } else {
      api.reload('259dd2ae', component.options)
    }
    module.hot.accept("./FormDocument.vue?vue&type=template&id=259dd2ae&scoped=true&", function () {
      api.rerender('259dd2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/documents/FormDocument.vue"
export default component.exports